import { isEmpty, deepCopy, getKeyOfData, isArray, findCheck } from '@/common/js/utils'
import { DAYS, SCENE, STRONG } from '@/views/create/kuaishou_local/components/actioninterest/data'
import { androidVersion, iOSVersion, deviceBrand, devicePrice, filterConvertLevel } from '@/data/kuaishou/datas'

export function ksCompile(data, orignData) {
  let target = deepCopy(data)
  if (isEmpty(target.district)) {
    // 参数不存在为系统定向
    target = Object.assign({}, orignData, target)
    target = convertSystemTarget(target)
  }
  const targetTypeItem = { key: 'auto_target', name: '定向方式' }
  const cityItem = { key: 'city', name: '地域' }
  const genderItem = { key: 'gender', name: '性别' }
  const ageItem = { key: 'age', name: '年龄' }
  const includeItem = { key: 'includes', name: '定向人群包' }
  const excludeItem = { key: 'excludes', name: '排除人群包' }
  const actionInterestItem = { key: 'behavior_type', name: '行为兴趣定向' }
  const actionSceneItem = { key: 'action_scene', name: '行为场景' }
  const actionDaysItem = { key: 'action_days', name: '行为天数' }
  const actionIntensityItem = { key: 'action_intensity', name: '行为强度' }
  const actionCatesItem = { key: 'action_tags', name: '行为分类' }
  const actionWordsItem = { key: 'action_tags', name: '行为关键词' }
  const interestCatesItem = { key: 'word_tags', name: '兴趣分类' }
  const androidItem = { key: 'android_osv', name: '安卓版本' }
  const iosItem = { key: 'ios_osv', name: 'iOS版本' }
  const brandItem = { key: 'device_brand', name: '设备品牌' }
  const priceItem = { key: 'device_price', name: '设备价格' }
  const networkItem = { key: 'network', name: '网络' }
  const behaviorItem = { key: 'app_behavior', name: 'APP定向' }
  const behaviorCateItem = { key: 'behavior_cate', name: 'APP分类' }
  const behaviorAppItem = { key: 'behavior_app', name: 'APP名称' }
  const filterConvertedItem = { key: 'filter_converted_level', name: '过滤已转化用户' }

  const getName = (item) => {
    return item.name || item.value
  }
  const {
    auto_target,
    cityData,
    gender,
    age,
    audienceData,
    behavior_type,
    action_scene,
    action_days,
    action_intensity,
    action_tags,
    word_tags,
    android_osv,
    ios_osv,
    device_brand,
    device_price,
    network,
    app_behavior,
    appData,
    mult_cate,
    filter_converted_level
  } = target

  const mult_city = cityData?.length && findCheck(cityData)

  if (isArray(mult_city) && mult_city.length) cityItem.values = mult_city.map(getName)
  else cityItem.all = true
  if (gender) genderItem.values = gender === 1 ? ['男'] : ['女']
  else genderItem.all = true
  if (isArray(age) && age.length) ageItem.values = [`${age[0]} ~ ${age[1]}`]
  else ageItem.all = true
  const includes = audienceData?.filter((ret) => ret.select === 'include').map(getName) || []
  const excludes = audienceData?.filter((ret) => ret.select === 'exclude').map(getName) || []
  if (includes.length) includeItem.values = includes
  else includeItem.hide = true
  if (excludes.length) excludeItem.values = excludes
  else excludeItem.hide = true
  if (behavior_type === 0) {
    actionInterestItem.all = true
    actionSceneItem.hide = true
    actionDaysItem.hide = true
    actionIntensityItem.hide = true
    actionCatesItem.hide = true
    actionWordsItem.hide = true
    interestCatesItem.hide = true
  } else if (behavior_type === 2) {
    actionInterestItem.values = ['系统优选']
    actionSceneItem.hide = true
    actionDaysItem.hide = true
    actionIntensityItem.hide = true
    actionCatesItem.hide = true
    actionWordsItem.hide = true
    interestCatesItem.hide = true
  } else if (behavior_type === 1) {
    actionInterestItem.values = ['自定义']
    const getLabel = (key, data) => {
      if (isArray(data)) {
        const labels = data.filter((met) => met.key === key)
        const label = labels.length ? labels[0].label : '数据匹配失败'
        return label
      }
      return '未知'
    }
    actionSceneItem.values = action_scene.map((ret) => getLabel(ret, SCENE))
    actionDaysItem.values = [`${DAYS[action_days]}天`]
    actionIntensityItem.values = [STRONG[action_intensity].label]
    if (isArray(action_tags)) {
      const actionCates = action_tags.filter((ret) => ret.type.toUpperCase() === 'CATEGORY').map(getName)
      const actionWords = action_tags.filter((ret) => ret.type.toUpperCase() === 'KEYWORD').map(getName)
      if (actionCates.length) actionCatesItem.values = actionCates
      else actionCatesItem.hide = true
      if (actionWords.length) actionWordsItem.values = actionWords
      else actionWordsItem.hide = true
    }
    if (isArray(word_tags) && word_tags.length) interestCatesItem.values = word_tags.map(getName)
    else interestCatesItem.hide = true
  }

  if (android_osv) {
    const osv = androidVersion.filter((ret) => ret.value === android_osv)
    if (osv.length) androidItem.values = [osv.pop().label]
    else androidItem.values = ['未知']
  } else androidItem.hide = true
  if (ios_osv) {
    const osv = iOSVersion.filter((ret) => ret.value === ios_osv)
    if (osv.length) iosItem.values = [osv.pop().label]
    else iosItem.values = ['未知']
  } else iosItem.hide = true
  if (isArray(device_brand) && device_brand.length) {
    const brand = device_brand.map((ret) => {
      const items = deviceBrand.filter((met) => met.id === ret)
      if (items.length) return items.pop().label
      return '未知'
    })
    brandItem.values = brand
  } else brandItem.all = true
  if (isArray(device_price) && device_price.length) {
    const price = device_price.map((ret) => {
      const items = devicePrice.filter((met) => met.id === ret)
      if (items.length) return items.pop().label
      return '未知'
    })
    priceItem.values = price
  } else priceItem.all = true
  const networkEmun = ['不限', 'Wi-Fi', '移动网络']
  if (network) networkItem.values = [networkEmun[network]]
  else networkItem.all = true

  if (app_behavior === 0) {
    behaviorItem.values = ['不限']
    behaviorAppItem.hide = true
    behaviorCateItem.hide = true
  } else if (app_behavior === 1) {
    behaviorItem.values = ['按APP分类']
    behaviorAppItem.hide = true
    const items = findCheck(appData)
    if (isArray(items) && items.length) {
      behaviorCateItem.values = items.map(getName)
    } else behaviorCateItem.all = true
  } else if (app_behavior === 2) {
    behaviorItem.values = ['按APP名称']
    behaviorCateItem.hide = true
    if (isArray(mult_cate) && mult_cate.length) {
      behaviorAppItem.values = mult_cate.map(getName)
    } else behaviorAppItem.all = true
  }

  if (filter_converted_level) filterConvertedItem.values = [filterConvertLevel[filter_converted_level].label]
  else filterConvertedItem.all = true
  if (auto_target) {
    targetTypeItem.values = ['智能定向']
    actionInterestItem.hide = true
    brandItem.hide = true
    priceItem.hide = true
    networkItem.hide = true
    behaviorItem.hide = true
  } else {
    targetTypeItem.values = ['自定义定向']
  }
  return [
    targetTypeItem,
    includeItem,
    excludeItem,
    cityItem,
    genderItem,
    ageItem,
    actionInterestItem,
    actionSceneItem,
    actionDaysItem,
    actionIntensityItem,
    actionCatesItem,
    actionWordsItem,
    interestCatesItem,
    androidItem,
    iosItem,
    brandItem,
    priceItem,
    networkItem,
    behaviorItem,
    behaviorAppItem,
    behaviorCateItem,
    filterConvertedItem
  ]
}

const defaulTargetParams = {
  // 定向
  region: [], // 地域ID列表
  app_interest: [], // APP行为-按分类
  app_ids: [], // APP行为-按应用
  exclude_population: [], // 定向人群包
  population: [], // 排除人群包
  action_tags: [],
  word_tags: [],
  mult_cate: [], // 选择的app名称
  categroyData: []
}

export function convertSystemTarget(target) {
  const sysAudiences =
    target.audience_dict?.map((ret) => {
      return {
        id: ret.orientation_id,
        key: ret.orientation_id,
        vaule: ret.orientation_name,
        name: ret.orientation_name,
        extend: ret.cover_num,
        type: ret.population_type,
        code: ret.third_platform_code
      }
    }) || []
  target = Object.assign({}, deepCopy(defaulTargetParams), target, { audienceData: sysAudiences })
  const { region, age, app_interest, app_ids, population, exclude_population, paid_audience, behavior_interest } = target

  const decompile = (Ids, data) => {
    if (isArray(Ids) && Ids.length) {
      Ids.forEach((ret) => {
        data.forEach((met) => {
          met.id === ret && (met.check = true)
        })
      })
    }
  }

  // 性别/Android版本/iOS版本/网络环境/设备品牌/设备价格__直接覆盖

  target.ageMode = age && Object.keys(age).length > 0 ? 'CUSTOM' : 'NONE'
  target.ageMode === 'CUSTOM' && (target.age = [age.min, age.max])
  target.district = region && region.length ? 'CITY' : 'NONE'
  target.audienceMode = isArray(population) || isArray(exclude_population) || isArray(paid_audience) ? 'AUDIENCE' : 'NONE'
  if (target.district === 'CITY') decompile(region, target.cityData)
  // app行为
  if (isArray(app_interest)) {
    target.app_behavior = 1
    decompile(app_interest, target.appData)
  } else if (isArray(app_ids)) {
    target.app_behavior = 2
    target.mult_cate = app_ids.map((ret) => {
      return {
        id: ret,
        name: ret
      }
    })
  }
  // 人群包
  if (target.audienceMode === 'AUDIENCE') {
    target.audienceData.map((ret) => {
      if (population && population.includes(ret.id)) {
        ret.select = 'include'
      } else if (exclude_population && exclude_population.includes(ret.id)) {
        ret.select = 'exclude'
      } else if (paid_audience && paid_audience.includes(ret.id)) {
        ret.select = 'include'
      }
    })
  }
  // 根据id查名称
  const getNameByKey = (ids, data, key) => {
    return ids.map((ret) => {
      const { value } = getKeyOfData(data, key, ret)
      return value
    })
  }
  // 行为兴趣
  const { behavior, interest } = behavior_interest || {}
  if (behavior || interest) target.behavior_type = 1
  else target.behavior_type = 0
  if (behavior) {
    const { keyword, label, time_type, strength_type, scene_type } = behavior
    if (isArray(keyword) && keyword.length) {
      target.action_tags.push(
        ...keyword.map((ret) => {
          return {
            id: ret.id,
            name: ret.name,
            type: 'KEYWORD'
          }
        })
      )
    }
    if (isArray(label) && label.length) {
      const names = getNameByKey(label, target.behaviorAndInterest.behavior, 'id')
      target.action_tags.push(
        ...label.map((ret, idx) => {
          return {
            id: ret,
            name: names[idx],
            type: 'CATEGORY'
          }
        })
      )
    }
    target.action_days = time_type
    target.action_intensity = strength_type
    target.action_scene = scene_type
  }
  if (interest) {
    const { label } = interest
    if (isArray(label) && label.length) {
      const names = getNameByKey(label, target.behaviorAndInterest.interest, 'id')
      target.word_tags.push(
        ...label.map((ret, idx) => {
          return {
            id: ret,
            name: names[idx],
            type: 'CATEGORY'
          }
        })
      )
    }
  }
  return target
}
